export class PaginationMeta
{
    defaults() {
        return {
          limit: 10,
          page: 1,
          totalItems: 0,
          totalPages: 1
        }
    }
}
